import React from 'react';
import * as Styles from "./about.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const AboutCard = (props) => {

    return (
        <Styles.AboutCard>
            <Styles.IconWarpper>
                <FontAwesomeIcon icon={props.icon} />
            </Styles.IconWarpper>
            <Styles.CardHeader>
                {props.title}
            </Styles.CardHeader>
            <Styles.CardBody>
                {props.body}
            </Styles.CardBody>
        </Styles.AboutCard>
    );

}
export default AboutCard;